import React, { Fragment } from 'react'
import multi from '../../assets/star-multicolor.png'
import star from '../../assets/star-white.svg'
import loading from '../../assets/loading.png'
import spacecadet from '../../assets/sc.svg'

import iconBack from '../../assets/icons/back.svg'
import iconX from '../../assets/icons/x.svg'

export const BigStar = () => {
  return (
    <Fragment>
      <img src={multi} alt="Multicolor Star" />
    </Fragment>
  )
}

export const LilStar = () => {
  return (
    <Fragment>
      <img src={star} alt="" className="medStar" />
    </Fragment>
  )
}

export const Loading = () => {
  return (
    <Fragment>
      <img src={loading} alt="" className="loading-image" />
    </Fragment>
  )
}

export const Spacecadet = () => {
  return (
    <Fragment>
      <a href="https://spacecadet.ventures/" target="_blank" rel="noreferrer" className="spacecadet-logo external-link">
        <img src={spacecadet} alt="Spacecadet" />
      </a>
    </Fragment>
  )
}

export const IconBack = () => {
  return (
    <Fragment>
      <img src={iconBack} alt="" className="icon-back" />
    </Fragment>
  )
}

export const IconX = () => {
  return (
    <Fragment>
      <img src={iconX} alt="" className="icon-x" />
    </Fragment>
  )
}
